import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { contactUs } from '@/apis/misc';
import type { IContactUs } from '@/types/misc';

type Result = boolean;
type Body = IContactUs;
type Options = UseMutationOptions<Result, unknown, Body>;

export function useContactUs(options?: Options) {
  return useMutation(contactUs, {
    ...options,
    onSuccess: (data, variables, context) => {
      if (options?.onSuccess) options?.onSuccess(data, variables, context);
    },
  });
}
